var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('span', { staticClass: "update-model-btn-span" }, [_c('pt-button', { attrs: { "theme": "primary", "type": "outlined", "disabled": !_vm.isUpdatable }, on: { "click": _vm.handleOpenAssetDialog } }, [_c('pt-icon', [_c('ic-replace-assets')], 1), _vm._v("\n    " + _vm._s(_vm.$t('playTurbo.custom.modelEdit.updateBtn')) + "\n  ")], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };